<template>
  <div class="text-center">
    <v-dialog persistent v-model="premiumDialog" width="350">
      <v-card>
        <v-card-title class="title gold white--text" primary-title>
          <v-icon class="mr-2" medium color="white">mdi-star-circle</v-icon>Premium Exercise
        </v-card-title>

        <v-card-text class="text-left py-3">
          This exercise is accessible by premium users only.
          Become a premium user today.
          <span
            class="font-weight-medium"
          >Contact +91 9811428849</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gold" text @click="$emit('close')">Okay</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "PremiumModal",
  props: ["premiumDialog"]
};
</script>

<style>
</style>